import { fontInter } from "./fonts/inter";
import { fontOpenSans } from "./fonts/open-sans";
import { fontPlusJakartaSans } from "./fonts/plus-jakarta-sans";
import { fontReadexPro } from "./fonts/readex-pro";

export const FontMap: Record<"OpenSans" | "ReadexPro" | "Inter" | "PlusJakartaSans", string> = {
  OpenSans: fontOpenSans.style.fontFamily,
  ReadexPro: fontReadexPro.style.fontFamily,
  Inter: fontInter.style.fontFamily,
  PlusJakartaSans: fontPlusJakartaSans.style.fontFamily,
};
